import { Button, Result } from 'antd-mobile';
import { ExclamationCircleOutline, RedoOutline } from 'antd-mobile-icons';
import s from './style.module.less';

export function ErrorSystemError() {
  return (
    <div className={s.root}>
      <Result
        className={s.result}
        description="当前系统维护中，请稍候刷新重试，或者联系管理员"
        icon={<ExclamationCircleOutline />}
        status="warning"
        title="系统维护中"
      />
      <Button color="primary" onClick={() => window.location.reload()}>
        <RedoOutline />
        重新加载
      </Button>
    </div>
  );
}
